/**
 * Invites
 */
export const Invites = (function () {

  var details;
  var data = [];
  var resendData = {};
  var apiUrl;
  var modal;

  var init = function () {

    //click event to add a new row with input fields
    $('#myds-add-invite').on('click', function (e) {
      e.preventDefault();

      addNewInputRow();
    });

    //click event that removes invite row
    $(document).on('click', '.myds-invite-remove', function (e) {
      e.preventDefault();
      $(this).parent().remove();
    });

    //on select:option change add or hide the +44 input from the invite
    $('.myds-invite-add').on('change', '.route', function () {
      if($(this).children('option:selected').val() == 'email') {
        $(this).next('.invite-dial').addClass('d-none')
      } else {
        $(this).next('.invite-dial').removeClass('d-none');
      }
    });

    $('#invites-modal').on('hidden.bs.modal', function (e) {
      $('input[type=text').each(function () {
        $(this).val('');
      });
      $('.additional-invite').remove();
    });

    $('#re-invites-modal').on('hidden.bs.modal', function (e) {
      $('[data-id]').each(function () {
        $(this).val('');
      });
    });
   
  }

  // opens modal to resend invite when clicking the button
  // populates modal with the details of the invitation to resent
  var openResendModal = function(element, ) {
    let btn = $(element).text();

    if ($(element).find('.badge').is(':visible') || btn.indexOf('Resend') >= 0) {
      $('#re-invites-modal').modal({
        backdrop: 'static',
        keyboard: false, //stops the modal from closing if clicking outside
        show: true
      });
      displayDetailsToResend(element);
    }
  }

  // Function that gets the 'resend' click event from the app
  // calls ajax request with the data to resend
  var reSendInvite = function(url) {
    var recipient = $('[data-id=recipient]').val()
    resendData.recipient = recipient;
    apiUrl = url + '/resend-invite/';
    //check the recipient details match the invite method
    var checkRecipient = validateField(recipient, $('[data-id=invite_method]').text());

    if(!checkRecipient) {
      return Util.toggleAlert('#myds-alert-resend-modal', checkRecipient, 'alert-warning', 8000);
    }

    return sendInvites([resendData], 'ds_events', resendData.invite_method, apiUrl);
  }

  //Function that gets the 'send' click event from the app
  //validates the fields on success it gets the details from the form to be sent to the ajax request
  var send = function (url) {
    $('input').removeClass('border-danger');
    if (validateFormFields()) {
      details = getInviteDetails();
      apiUrl = url + '/send-invite/';
      return sendInvites(details, 'ds_events', details[0].invite_method, apiUrl);
    }
  }

  //Checks each input field in the invite modal and calls validateField()
  //returns a boolean
  var validateFormFields = function() {
    let result = true;
    $('.input-group').each((e, input) => {
      var name = $(input).find('input[name="name"]');
      var known = $(input).find('input[name="invite"]');
      var route = $(input).find('.route option:selected');
      var contact = $(input).find('input[name="recipient"]');

      var fieldsToValidate = [name, known, route, contact];
      
      fieldsToValidate.forEach((el, index) => {
          var previousIndex = index - 1 === -1 ? 0 : index - 1;
          var valid = validateField(el.val(), fieldsToValidate[previousIndex].val());

          if(!valid) {
            el.addClass('border-danger');
            Util.toggleAlert('#myds-alert-modal', valid, 'alert-warning', 8000);
            result = false;
          }
      });
    });

    return result;

  }

  //Validates all fields - checks if they are not empty and in correct format
  var validateField = function (value, previousValue) {
    //TODO - add international input- change to dropdown choose
    //checks start number with either +44 or 0 followed by 9 or 10 digits
    //allows the digits to be separated by spaces in any way.
    var regPhone = /^(?:0|\+?44)(?:\d\s?){9,10}$/;
    var regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (value == '') {
        return 'All fields must be filled';
      } else if (previousValue == 'sms' && !regPhone.test(value)) {
        return 'Contact details must be a valid UK number';
      } else if (previousValue == 'email' && !regEmail.test(value)) {
        return 'Contact details must be a valid email format';
      } 
      
      return true;
  }

  var validation = {
    /**
     * @description Checks the email address field is not empty and that the email address is valid
     * @memberof module:Invites.validation
     * @param {string} email address
     * @return {boolean}
    */
    checkEmails: function (val) {
      var check_email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!val) {
        return false;
      }
      val.forEach(el => {
        if (!(check_email.test(el)) && (el !== "")) {
          return false;
        }
      });
      return true;
    },
    /** 
     * @description Checks the SMS number field is not empty and that the SMS is valid

     * @memberof module:Invite.validation
     * @param {string} sms number
     * @return {boolean}
    */
    checkSMS: function (val) {
      var check_sms = /^(?:0|\+?44)(?:\d\s?){9,10}$/;
      if (!val) {
        return false;
      }
      val.forEach(el => {
        if (!(check_sms.test(el)) && (el !== "")) {
          return false;
        }
      });
      return true;
    }
  };

  // Get the invites details of the inputs
  var getInviteDetails = function () {
    data = [];
    $('.input-group').each((e, input) => {
      var name = $(input).find('input[name="name"]').val();
      var known = $(input).find('input[name="invite"]').val();
      var route = $(input).find('.route option:selected').val();
      var contact = $(input).find('input[name="recipient"]').val();
      
      if (route == 'sms') {
        contact = '44' + formatNumber(contact);
      }

      data.push({
        name: name,
        known_as: known,
        recipient: contact,
        invite_method: route
      });
    });

    return data;
  }

  //Creates additional rows with input fields below the previous one
  var addNewInputRow = function () {
    var html = [];
    html.push(`<div class="input-group additional-invite">
              <input type="text" name="name" class="form-control m-2" placeholder="Name...">
              <input type="text" name="invite" class="form-control m-2" placeholder="Known As...">
              <select class="custom-select m-2 route"> 
                <option value="sms">SMS</option>
                <option value="email">Email</option>
              </select>
              <input type="tel" class="form-control mt-2 mb-2 ml-0 bg-light invite-dial" value="+44" disabled>            
              <input type="text" name="recipient" class="form-control mt-2 mb-2" placeholder="Details...">
              <button type="submit" value="+" class="btn btn-primary m-2 myds-invite-remove"><i class="fas fa-trash-alt"></i></button>
              </div>`);
    $('.myds-invite-add').append(html);
  }

  //Ajax request to send/resend invites
  var sendInvites = function (invites, dataset, route, url) {
    var csrf = Util.getCSRF();

    return $.ajax({
      type: 'POST',
      dataType: 'json',
      headers: {
        'isAPI': true,
        'x-csrf-token': csrf
      },
      url: '/invites/' + url + route,
      data: {
        invites: invites,
        dataset: dataset
      }
    });
  }

  /**
   * @description Any functions that deal with HTTP requests
   */
  var http = {
    /*
    * @description Sends the list of dashboard invites using the ajax request and the 'send-invite' route
    * 
    * @memberof module:Invites.http
    * @param {string} `url` URL to send to 
    * @param {object} `payload` The list of offers depending on toggle selection
    */
    send: function (url, payload) {
  
     return $.ajax({
       url: url,
       type: 'post',
       data: {
         payload: payload
       },
       headers: {
         'isAPI': true,
         'x-csrf-token': Util.getCSRF() 
       }
     });
    },
  }
  
  //Formats phoneNumber removing any 0's  at start
  var formatNumber = function (number) {
    return parseInt(number, 10);
  }

  var splitInputLists = function (input_list)
  {
    return input_list ? input_list.split(/[\s,]+/) : [];  
  }
  var filterDuplicates = function (input_list)
  {
    return input_list.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.recipient === value.recipient
    ))); 
  }
  /**
   * Takes a list of strings and returns a list of objects
   * with the values required for a invites payload
   * 
   * @param {*} payload 
   * @param {*} invite_method 
   * @param {*} invite_app 
   * @param {*} subscriber_id 
   * @returns 
   */
  var mapPayload = function (payload, invite_method, invite_app, subscriber_id)
  {
    switch (invite_method) {
      case 'email':
        return payload.map(function (recipient) {
          return {
            'recipient': recipient,
            'invite_method': invite_method,
            'invite_app':invite_app
          }
        });
      case 'sms':
        return payload.map(function (recipient) {
          return {
            'recipient': `44${recipient}`,
            'invite_method': invite_method,
            'invite_app':invite_app
          }
        }); 
      default:
        throw Error("Invalid invite method");
    }
  }

  /**
   * opens modal to resend invitation
   * gets the details and calls getDetailsToResend to display the details in the modal
   * Html code must have the following data attributes, as this is what allows to populate the resend modal
   * <input data-contact="" data-route="" data-known="" data-name="" data-status="">
   * @param {*} element global object clicked
   */
  var displayDetailsToResend = function (element) {
      var resendModal = $('#myds-resend-invites');
      var input = $(element).next('input');

      resendData.name = input.data('name');
      resendData.known_as = input.data('known');
      resendData.invite_method = input.data('route');
      resendData.invite_id = input.data('member-id');

      resendModal.find('[data-id=name]').html(resendData.name)
      resendModal.find('[data-id=known_as]').html(resendData.known_as)
      resendModal.find('[data-id=recipient]').val(input.data('contact'))
      resendModal.find('[data-id=invite_method]').html(resendData.invite_method)
      resendModal.find('[data-id=status]').html(input.data('status'))
  }
  
  return {
    init: init,
    send: send,
    resend: reSendInvite,
    openResendModal: openResendModal,
    splitInputLists : splitInputLists,
    filterDuplicates : filterDuplicates,
    /**
     * Refactored return objects
     */
    mapPayload : mapPayload,
    validation : validation,
    http : http
  }

}());